<div mat-dialog-content
	class="cm-ranch-create-step-content">
	<h3 class="cm-ranch-create-step-heading">
		{{ 'Fertilizers' | translate }}
	</h3>

	<p class="cm-ranch-create-step-help">
		Add at least one fertilizer to get fertilization recommendations. Choose from the list or create your own.
	</p>

	<button
		class="bk-button bk-create-button cm-ranch-create-add-button"
		(click)="openAddFertilizerDialog()">
		<mat-icon class="cm-ranch-create-add-button__icon">add</mat-icon>
		{{'Add Fertilizer' | translate }}
	</button>

	<table *ngIf="fertilizerControls.length > 0"
		class="bk-form__table cm-irrigation-methods-ui__table">
		<colgroup>
			<col span="1" class="cm-irrigation-methods-ui__col1">
			<col span="1" class="cm-irrigation-methods-ui__col2">
			<col span="1" class="cm-irrigation-methods-ui__col3">
			<col span="1" class="cm-irrigation-methods-ui__col4">
		</colgroup>
		<thead>
			<th>
				{{ 'Name' | translate }}
			</th>
			<th>
				{{ 'Formulation' | translate }}
			</th>
			<th class="cm-tcell--align-right">
				{{ 'Nitrogen' | translate }} %
			</th>
			<th>
				{{ 'Action' | translate }}
			</th>
		</thead>
		<tbody>
			<tr *ngFor="let fertilizer of fertilizerControls; let i = index"
				class="cm-table-row--padded">
				<td>
					{{ fertilizer.get('Name').value }}
				</td>
				<td>
					{{ fertilizer.get('FormulationType').value?.Name }}
				</td>
				<td class="cm-tcell--align-right">
					{{ fertilizer.get('PercentageN').value }}
				</td>
				<td class="cm-irrigation-methods-ui__action">
					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="deleteFertilizer(i, $event)">
						<mat-icon matTooltip="{{ 'Delete' | translate }}">delete</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div mat-dialog-actions
	align="end">
	<button class="bk-button__delete"
		(click)="cancel()">
		{{ 'Cancel' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
		(click)="back()">
		{{ 'Back' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium"
		[disabled]="form && !form.valid"
		(click)="next()">
		{{ 'Next Step' | translate }}
	</button>
</div>
